// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".YNFsevwDpYV60E {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  color: var(--ds-icon, #44546f);\n  padding: 0;\n  text-decoration: none;\n}\n.YNFsevwDpYV60E:active,\n.YNFsevwDpYV60E:hover {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  color: var(--ds-icon-accent-gray, #758195);\n  cursor: pointer;\n  outline: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeButton": "YNFsevwDpYV60E"
};
export default ___CSS_LOADER_EXPORT___;
